/* eslint-disable */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import RealCaseContent from '../../components/RealCaseContent';
import CaseTabsContent from "../../components/CaseTabsContent";
import caseTopBg from '../../../../../../assets/sme/ics/case_top_bg.png';
interface ISection2Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const param = useParams();
  const ID = '4';
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(() => settings?.paragraphs[3], [settings]);
  const updateComponentState = useUpdateComponentState();

  const quiz = paragraphsSettings?.quiz;

  return (
    <div className="topic-section-3">
      <RealCaseContent
        backgroundImage={caseTopBg}
        headingLines={paragraphsSettings.exampleHeading}
        descTitle={paragraphsSettings.descTitle}
        overviewList={paragraphsSettings.overviewList}
        dataSource={paragraphsSettings.dataSource}
        dataSourceList={paragraphsSettings.dataSourceList}
      />
      <CaseTabsContent item={paragraphsSettings?.case} />
      <div
        id="sme-ics-section3-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'sme-ics-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section3;
